import React, { useEffect, useState } from 'react'
import Header from '../../Components/Header'
import PageHeader from '../../Components/PageHeader/PageHeader'
import { leftArrow } from '../../common/Assets/imgs';
import { useLocation, useNavigate } from 'react-router-dom';
import { put } from '../../Services/ApiHandler';
import { URLS } from '../../Services/Constant';
import toast from 'react-hot-toast';

const Helpview = () => {
    const navigate=useNavigate();
    const location = useLocation();
const { data, type } = location.state || {};
console.log("data.id", data.id);
console.log('location',location);
const [isLoading, setIsLoading] = useState(false);


     const handleChange = (key, value) => {
        setForm({ ...form, [key]: value });
    };
     const [isEdit,setIsEdit]=useState(false);
     const [form, setForm] = useState({
           username:'',
           datetime:'',
           status:'',
           usertype:'',
           description:'',
           mobilenumber:'',
        });

        useEffect(()=>{
            setForm({
                username:data?.user_name,
                datetime:data?.date_time,
                status:data?.status,
                usertype:data?.user_type,
                description:data?.description,
                mobilenumber:data?.mobile,
            })

        },[])

        const handleResolve = async () =>{
          
             const payload = new FormData();
            //   payload.append("type",form?.)
            try{
                 setIsLoading(true);
                const res = await put (`${URLS.HELP_RESOLVED}${data?.id}/`)
                if(res?.status === "success"){
                    toast.success(res?.message || "Support request resolved successfully")
                     setIsLoading(false);
                    navigate(-1);
                }
            }
            catch(err){
                console.log('err',err);
                
            }finally{
               setIsLoading(false);
            }
        }
    
//         useEffect(() => {
//   if (data) {
//     setForm({
//       user_name: data?.user_name || "",
//       date_time: data?.date_time || "",
//       status: data?.status || "",
//       user_type: data?.user_type || "",
//       description: data?.description || "",
//     });
//   }

//   if (type === "view") {
//     setIsEdit(false);
//   } else {
//     setIsEdit(true);
//   }

// }, [data, type]);



useEffect(() => {
  if (data) {
    setForm({
      user_name: data?.user_name || "",
      date_time: data?.date_time || "",
      status: data?.status || "",
      user_type: data?.user_type || "",
      description: data?.description || "",
      mobilenumber:data?.mobile || "",
    });
  }

  setIsEdit(type !== "view");

}, [data, type]);

  return (
    <>
        <Header/>
    <div style={{marginTop:'7rem',paddingLeft:'15px',paddingRight:'10px' }}>
          {/* Header */}
                       <div onClick={() => navigate(-1)} className="admin-header">
                           <img src={leftArrow} className="back-icon-arrow" />
                           <h2>Help & Support</h2>
                       </div>
         {/* Form */}
                <div className="admin-form">


                    {/* Row 1 */}
                    <div className="form-groups">
                        <label>User Name</label>
                        <input
                            type="text"
                            value={form.user_name}
                            onChange={(e) => handleChange("user_name", e.target.value)}
                            readOnly ={!isEdit}
                        />
                    </div>

                    <div className="form-groups">
                        <label>Date & Time</label>
                        <input
                            type="text"
                            value={form.date_time}
                            onChange={(e) => handleChange("date_time", e.target.value)}
                            readOnly ={!isEdit}
                        />
                    </div>

                    {/* Row 2 */}
                    <div className="form-groups">
                        <label>Status</label>
                        <input
                            type="text"
                            className={`${form.status === "Pending"?"text-danger":"text-success"}`}
                            value={form.status}
                            onChange={(e) => handleChange("status", e.target.value)}
                            readOnly={!isEdit}
                       />
                    </div>
                    <div className="form-groups">
                        <label>User Type</label>
                        <input
                            type="text"
                            value={form.user_type}
                            onChange={(e) => handleChange("user_type", e.target.value)}
                            readOnly={!isEdit}
                       />
                    </div> 
                    
                     {/* Row 3 */}
                    <div className="form-groups">
                        <label>Mobile Number</label>
                        <input
                            type="text"
                            // className={`${form.status === "Pending"?"text-danger":"text-success"}`}
                            value={form.mobilenumber}
                            onChange={(e) => handleChange("mobilenumber", e.target.value)}
                            readOnly={!isEdit}
                       />
                    </div>
                
                </div>

                  <div className="form-groups mt-3" style={{maxWidth:'900px'}}>
                        <label>Description</label>
                        <input
                            type="text"
                            value={form.description}
                            onChange={(e) => handleChange("description", e.target.value)}
                            readOnly={!isEdit}
                       />
                    </div> 

                    <div className='d-flex justify-content-end mt-4  w-85'>
                        {form?.status === "Pending" && (
                        <button className='resolve-btn'
                        onClick={handleResolve}>
                             {isLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "white", padding: 8 }}
                  ></span>
                </>
              ) : (
                "Resolved"
              )}
                            {/* Resolved */}
                            </button>
                            )}
                    </div>

                

        </div>
        </>
  )
}

export default Helpview